import { render, staticRenderFns } from "./ContactsField.vue?vue&type=template&id=01696a76"
import script from "./ContactsField.vue?vue&type=script&lang=js"
export * from "./ContactsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports